import { cn } from "@/lib/utils";

import { HintIcon } from "./hint-icon";

export const KPI_HINT_ARIA_LABEL = "O que este indicador representa";

export type KpiTone = "neutral" | "amber" | "red";

const TONE_CLASSES: Record<KpiTone, string> = {
  neutral: "bg-muted/30 border-border",
  amber: "bg-amber-50 border-amber-200",
  red: "bg-red-50 border-red-200",
};

export interface KpiCardProps {
  label: string;
  value: string;
  tone?: KpiTone;
  icon?: JSX.Element;
  hint?: string;
}

export function KpiCard({
  label,
  value,
  tone = "neutral",
  icon,
  hint,
}: KpiCardProps): JSX.Element {
  return (
    <div
      className={cn(
        "border rounded-lg px-4 py-3 flex flex-col gap-1",
        TONE_CLASSES[tone],
      )}
    >
      <span className="flex items-center gap-1 text-xs uppercase tracking-wider text-muted-foreground">
        {icon}
        <span className="flex-1">{label}</span>
        {hint ? (
          <HintIcon text={hint} ariaLabel={KPI_HINT_ARIA_LABEL} />
        ) : null}
      </span>
      <span className="text-lg font-semibold tabular-nums">{value}</span>
    </div>
  );
}
